import React from 'react';
import { Pie } from '@ant-design/plots';
import { Card } from 'antd';
import GraphLoader from '../../../../../../../../Components/ContentLoaders/GraphLoader';
import { EmptyState } from '../../../../../../../../Packages/EmptyState';

const BenchmarkPieChart = (props) => {
    const data = props.fetchCantAnswerResponseApi.data != null ? props.fetchCantAnswerResponseApi.data : []

    const config = {
        height: 450,
        //   padding: [120, 24, 48, 48],
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 0.8,
        color: ['#74add1', '#4575b4', '#fdae61', '#E83E8C', '#5F63F2'],
        interactions: [{ type: 'element-active' }],
        legend: {
            position: 'top',

            itemSpacing: 20,
            maxItemWidth: 400,

            marker: {
                symbol: 'square',
                style: {
                    r: 7,
                    // size: 20,            
                },
            },
            itemName: {

                style: {
                    fontSize: 14,
                    fontWeight: 400,
                },
            },
        },

        tooltip: {
            formatter: (datum) => {
                return { name: datum.type, value: `${datum.value.toFixed(2)}%` };
            },
        },
        interactions: [
            { type: 'legend-filter', enable: false },
            { type: 'legend-highlight', enable: false },
        ],
        label: {
            position: 'outside',
            formatter: (item) => `${item.value}%`,
            style: {
                fill: '#333',
                fontWeight: 400,
                fontSize: 18,
            },
            labelLine: null
        },
    };

    return (
        <div className='cardwrapper'>
            <h3>Can't Answer Responses</h3>
            <p className='description-container'>This chart shows the categories where feedback providers provided a "Can't" Answer" response. User filters to further identify which category of feedback providers tend to give this response. Insights from this data can help modify and enhance the questionnaire.</p>
            {/* <h3 style={{ marginBottom: '16px' }}>% of 'Can\'t Answer' Responses</h3> */}
            {
                props.fetchCantAnswerResponseApi.isProcessing ? <GraphLoader height={300} width={600} /> :
                    (props.fetchCantAnswerResponseApi.error && props.fetchCantAnswerResponseApi.data === null) || (props.fetchCantAnswerResponseApi.data != null && props.fetchCantAnswerResponseApi.data.length === 0) ?
                        < EmptyState emptyStateMessage="No data found" /> :
                    <Pie
                        {...config}
                        style={{
                            height: '400px',
                        }}
                    />
            }
        </div>
    );
};

export default BenchmarkPieChart;
